import { NgModule } from "@angular/core";

import { sharedModule } from "src/app/shared/shared.module";
import { PlacementReservationComponent } from "./placement-reservation.component";
import { PlacementReservationListComponent } from "./placement-reservation-list/placement-reservation-list.component";
import { PlacementReservationEntryComponent } from "./placement-reservation-entry/placement-reservation-entry.component";
import { ConfirmPlacementEntryComponent } from "./placement-reservation-list/confirm-placement-entry/confirm-placement-entry.component";
import { PlacementPaymentComponent } from "./placement-payment/placement-payment.component";
import { PlacementReportComponent } from './placement-report/placement-report.component';
import { PlacementDetailComponent } from './placement-reservation-list/placement-detail/placement-detail.component';
import { PlacementSearchComponent } from './placement-reservation-list/placement-search/placement-search.component';

@NgModule({
  declarations: [
    PlacementReservationComponent,
    PlacementReservationListComponent,
    PlacementReservationEntryComponent,
    ConfirmPlacementEntryComponent,
    PlacementPaymentComponent,
    PlacementReportComponent,
    PlacementDetailComponent,
    PlacementSearchComponent
  ],
  imports: [sharedModule],
  entryComponents: [
    PlacementReservationEntryComponent,
    ConfirmPlacementEntryComponent,
    PlacementPaymentComponent,
    PlacementReportComponent,
    PlacementDetailComponent,
    PlacementSearchComponent
  ]
})
export class PlacementReservationModule {}
